import {
  User,
  Settings,
  CreditCard,
  HelpCircle,
  LogOut,
  Crown,
  Shield
} from 'lucide-react'
import { Link } from 'react-router-dom'

const ProfileDropdown = ({ user, onClose, onLogout }) => {
  const menuItems = [
    {
      icon: User,
      label: 'Profile',
      href: '/dashboard/profile',
      description: 'Manage your account'
    },
    // {
    //   icon: Settings,
    //   label: 'Settings',
    //   href: '/dashboard/settings',
    //   description: 'Preferences & configuration'
    // },
    // {
    //   icon: CreditCard,
    //   label: 'Billing',
    //   href: '/dashboard/billing',
    //   description: 'Manage subscription'
    // },
    {
      icon: HelpCircle,
      label: 'Help & Support',
      href: '/dashboard/support',
      description: 'Get help and support'
    }
  ]

  const getSubscriptionBadge = (subscription) => {
    switch (subscription) {
      case 'pro':
        return (
          <div className="flex items-center space-x-1 text-accent-400">
            <Crown className="w-4 h-4" />
            <span className="text-xs font-medium">Pro</span>
          </div>
        )
      case 'enterprise':
        return (
          <div className="flex items-center space-x-1 text-primary-400">
            <Shield className="w-4 h-4" />
            <span className="text-xs font-medium">Enterprise</span>
          </div>
        )
      default:
        return (
          <div className="flex items-center space-x-1 text-secondary-400">
            <span className="text-xs font-medium">Free</span>
          </div>
        )
    }
  }

  return (
    <>
      {/* Backdrop */}
      <div
        className="fixed inset-0 z-[9997]"
        onClick={onClose}
      />

      {/* Dropdown */}
      <div className="absolute right-0 mt-2 w-80 bg-secondary-800 border border-secondary-700 rounded-xl shadow-xl z-[9998]">
        {/* Header */}
        <div className="p-6 border-b border-secondary-700">
          <div className="flex items-center space-x-3">
            <div className="w-12 h-12 bg-gradient-to-r from-primary-500 to-accent-500 rounded-full flex items-center justify-center">
              {user?.avatar ? (
                <img
                  src={user.avatar}
                  alt={user.name}
                  className="w-12 h-12 rounded-full object-cover"
                />
              ) : (
                <User className="w-6 h-6 text-white" />
              )}
            </div>
            <div className="flex-1">
              <h3 className="text-white font-semibold">{user?.name || 'User'}</h3>
              <p className="text-secondary-400 text-sm">{user?.email}</p>
              {getSubscriptionBadge(user?.subscription)}
            </div>
          </div>
        </div>

        {/* Menu Items */}
        <div className="py-2">
          {menuItems.map((item, index) => (
            <Link
              key={index}
              to={item.href}
              onClick={onClose}
              className="flex items-center space-x-3 px-6 py-3 hover:bg-secondary-700 transition-colors group"
            >
              <item.icon className="w-5 h-5 text-secondary-400 group-hover:text-primary-400 transition-colors" />
              <div className="flex-1">
                <div className="text-white font-medium">{item.label}</div>
                <div className="text-secondary-400 text-sm">{item.description}</div>
              </div>
            </Link>
          ))}
        </div>

        {/* Divider */}
        <div className="border-t border-secondary-700"></div>

        {/* Logout */}
        <div className="py-2">
          <button
            onClick={() => {
              onLogout()
              onClose()
            }}
            className="flex items-center space-x-3 px-6 py-3 hover:bg-error-500/10 transition-colors group w-full text-left"
          >
            <LogOut className="w-5 h-5 text-error-500 group-hover:text-error-600 transition-colors" />
            <div className="flex-1">
              <div className="text-error-500 font-medium">Sign Out</div>
              <div className="text-secondary-400 text-sm">End your session</div>
            </div>
          </button>
        </div>
      </div>
    </>
  )
}

export default ProfileDropdown
